import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Anchor, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <footer className="mt-24 border-t border-white/10 bg-[#0C1322]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-9 h-9 bg-[#FF5722] flex items-center justify-center">
                <Anchor size={18} strokeWidth={2.5} className="text-white" />
              </div>
              <div className="leading-none">
                <div className="font-display font-black text-white text-[15px]">BILLTECH HOLDINGS</div>
                <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-[#94A3B8] mt-[2px]">Marine &amp; Engineering Group</div>
              </div>
            </div>
            <p className="text-sm text-[#94A3B8] leading-relaxed">
              Integrated marine & engineering infrastructure for the global offshore energy industry.
              Eight strategic divisions. One unified QHSE standard.
            </p>
          </div>

          <div>
            <div className="eyebrow mb-4">Group</div>
            <ul className="space-y-2 text-sm text-white/80">
              <li><Link to="/about" className="hover:text-[#FF5722]">Corporate Profile</Link></li>
              <li><Link to="/divisions" className="hover:text-[#FF5722]">Divisions</Link></li>
              <li><Link to="/subsidiaries" className="hover:text-[#FF5722]">Subsidiaries</Link></li>
              <li><Link to="/fleet" className="hover:text-[#FF5722]">Fleet & Assets</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-4">Engage</div>
            <ul className="space-y-2 text-sm text-white/80">
              <li><Link to="/careers" className="hover:text-[#FF5722]">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-[#FF5722]">Submit RFQ</Link></li>
              <li><Link to="/admin" className="hover:text-[#FF5722]">Client Portal</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2"><Mail size={14} className="mt-0.5 text-[#FF5722]" /> <span>tenders@billtechgroup.com</span></li>
              <li className="flex items-start gap-2"><Phone size={14} className="mt-0.5 text-[#FF5722]" /> <span>+1 (713) 555-0179</span></li>
              <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5 text-[#FF5722]" /> <span>Houston · Aberdeen · Lagos · Singapore</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#64748B] font-mono uppercase tracking-widest">
            © {new Date().getFullYear()} Billtech Holdings — Marine &amp; Engineering Group
          </p>
          <p className="text-xs text-[#64748B] font-mono uppercase tracking-widest">
            A Global Offshore Group · ISO 9001 · ISM · ISPS
          </p>
        </div>
      </div>
    </footer>
  );
}
